export const environment = {
    production: false,
    serviceMainBaseUrl: 'https://apigw.etfr.eurofins.com/hybiouat/server/',
    launcherUrl: 'https://launcheruat.etfr.eurofins.com',
    appCode: 'APP0000029',
    appName: 'HyBio UAT',
    name: 'UAT-EXT',
};
